"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RxapUtilitiesError = exports.RxapError = void 0;
const tslib_1 = require("tslib");
const deprecated_1 = require("./decorators/deprecated");
class RxapError extends Error {
    constructor(_packageName, message, code, scope, stack) {
        super(message);
        this._packageName = _packageName;
        this.code = code;
        this.scope = scope;
        this.stack = stack;
        if (Error['captureStackTrace']) {
            Error['captureStackTrace'](this, RxapError);
        }
        this.name = 'RxapError';
    }
    get packageName() {
        return this._packageName;
    }
    get className() {
        return this.scope;
    }
    toJSON() {
        return {
            package: this.packageName,
            message: this.message,
            code: this.code,
            scope: this.scope,
            className: this.scope,
            stack: this.stack,
        };
    }
    /**
     * Add's the sub package name to the current package name.
     *
     * current package name -> with sub package name
     * @rxap/package -> @rxap/package/sub
     *
     * @internal
     * @param subPackageName The sub package name
     * @deprecated use addSubPackageName instead
     */
    setSubPackageName(subPackageName) {
        this.addSubPackageName(subPackageName);
    }
    /**
     * Add's the sub package name to the current package name.
     *
     * current package name -> with sub package name
     * @rxap/package -> @rxap/package/sub
     *
     * @internal
     * @param subPackageName The sub package name
     * @deprecated removed
     */
    addSubPackageName(subPackageName) {
        this._packageName = [this._packageName, subPackageName].join('/');
    }
    /**
     * Sets the package name
     *
     * @internal
     * @param packageName The new package name
     */
    setPackageName(packageName) {
        this._packageName = packageName;
    }
}
exports.RxapError = RxapError;
tslib_1.__decorate([
    (0, deprecated_1.Deprecated)('use addSubPackageName instead'),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", void 0)
], RxapError.prototype, "setSubPackageName", null);
tslib_1.__decorate([
    (0, deprecated_1.Deprecated)('removed'),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", void 0)
], RxapError.prototype, "addSubPackageName", null);
class RxapUtilitiesError extends RxapError {
    constructor(message, code, className, stack) {
        super('@rxap/utilities', message, code, className, stack);
    }
}
exports.RxapUtilitiesError = RxapUtilitiesError;
